import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";
import { getRemoteConfig, RemoteConfig } from "firebase/remote-config";
import { firebaseConfig } from "./config";

let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;
let remoteConfig: RemoteConfig;

// 初始化 Firebase App
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// 初始化服務
auth = getAuth(app);
db = getFirestore(app);
storage = getStorage(app);
remoteConfig = getRemoteConfig(app);

// 設定 Remote Config 設定
// 在開發環境使用較短的間隔，生產環境使用較長間隔
const isDev = import.meta.env.DEV;
remoteConfig.settings = {
  fetchTimeoutMillis: 10000, // 10 秒
  minimumFetchIntervalMillis: isDev ? 0 : 60000, // 開發環境：0（無限制），生產環境：1 分鐘
};

export { app, auth, db, storage, remoteConfig };

